(function() {
    'use strict';
    window.addEventListener('load', function() {
        var forms = document.getElementsByClassName('needs-validation');
        Array.prototype.forEach.call(forms, function(form) {
            form.addEventListener('submit', function(event) {
                form.querySelectorAll('[required]').forEach(function(el) {
                    if (!el.offsetParent) {
                        el.removeAttribute('required');
                    }
                });
                if (!form.checkValidity()) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.querySelectorAll('[required]').forEach(function(el) {
                    if (!el.offsetParent) return;
                    if (el.value.trim() === '') {
                        el.classList.add('is-invalid');
                        el.classList.remove('is-valid');
                    } else {
                        el.classList.add('is-valid');
                        el.classList.remove('is-invalid');
                    }
                });
                $(form).find('.form-control-chosen[required]').each(function() {
                    let $select = $(this);
                    if (!$select.is(':visible')) return;
                    let $ui = $select.next();
                    if ($select.val() === '') {
                        $ui.removeClass('is-valid').addClass('is-invalid');
                    } else {
                        $ui.removeClass('is-invalid').addClass('is-valid');
                    }
                });
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();
